module.exports = __webpack_public_path__ + "img/lcbz4.af01884e.png";